module.exports = __webpack_public_path__ + "img/draggable.2eb3c85a.svg";